import { render, staticRenderFns } from "./NoteEditorModal.vue?vue&type=template&id=458962fa"
import script from "./NoteEditorModal.vue?vue&type=script&lang=js"
export * from "./NoteEditorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports